import React from 'react';
import { Edit2, Trash2 } from 'react-feather';



export const products = [
    {
        id: 1,
        collectionName: 'Beers & Ciders',
        addedBy: 'Ravi',
        status: 'active',
        createdBy: '14/01/2024',
        UpdatedBy: '22/01/2024',

    },
    {
        id: 2,
        collectionName: 'Beers & Ciders',
        addedBy: 'Ravi',
        status: 'Inactive',
        createdBy: '14/01/2024',
        UpdatedBy: '22/01/2024',

    },
    {
        id: 3,
        collectionName: 'Beers & Ciders',
        addedBy: 'Ravi',
        status: 'active',
        createdBy: '14/01/2024',
        UpdatedBy: '22/01/2024',

    },
]






export const orderColumns = [
    {
        name: 'Collection Name',
        selector: row => row['collectionName'],
        sortable: true,
        center: true,
        cell: (row) => (
            <p style={{ fontWeight: '500' }}>
                {row.collectionName}
            </p>
        )
    },
    {
        name: 'Added By',
        selector: row => `${row.addedBy}`,
        sortable: true,
        center: true,
        cell: (row) => (
            <div className='d-flex justify-content-end align-items-center'>
                <p style={{ fontWeight: '500' }}>{row.addedBy}</p>

            </div>
        )
    },
    {
        name: 'Status',
        selector: row => `${row.status}`,
        sortable: true,
        center: true,
        cell: (row) => (
            <div className='d-flex justify-content-end align-items-center'>
                <p style={{ fontWeight: '500' }}>{row.status}</p>

            </div>
        )
    },
    {
        name: 'Created Date',
        selector: row => `${row.createdBy}`,
        cell: (row) => (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <p style={{ fontWeight: '500' }}>{row.createdBy}</p>
            </div>
        ),
        sortable: true,
        center: true,
    },
    {
        name: 'Updated Date',
        selector: row => `${row.UpdatedBy}`,
        sortable: true,
        center: true,
        cell: (row) => (
            <div className='d-flex justify-content-center align-items-center'>
                <p className='text-center font-medium'>{row.UpdatedBy}</p>
            </div>
        ),

    },
    {
        name: 'Actions',
        cell: (row) => (
            <div className='d-flex justify-content-center align-items-center' style={{ marginLeft: '20px' }}>

                <span className='rounded-2' style={{ cursor: 'pointer', marginRight: '10px', border: '1px solid #008000', padding: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Edit2 color='#008000' size={16} />
                </span>
                <span className='rounded-2' style={{ cursor: 'pointer', border: '1px solid #ff0000', padding: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Trash2 color='#ff0000' size={16} />
                </span>
            </div>
        ),
        sortable: false,
        center: true,
    }
]
export const spinnerData = [{
    id: 33,
    heading: 'Loader 31',
    spinnerClass: 'loader-35'
}]